export default {
  "edeka.region.Minden-Hannover": "Minden-Hannover",
  "edeka.region.Rhein-Ruhr": "Rhein-Ruhr",
  "edeka.region.Nord": "Nord",
  "edeka.region.Südwest": "Südwest",
  "edeka.region.Nordbayern-Sachsen-Thüringen": "Nordbayern-Sachsen-Thüringen",
  "edeka.region.Südbayern": "Südbayern",
  "edeka.region.Hessenring": "Hessenring",
  "edeka.region.EDEKA Zentrale": "EDEKA Zentrale",
};
